<div>
    <div class="refresh">
        <app-document-editor-menu [editor]="editor" [toolbar]="toolbar"></app-document-editor-menu>
        <button (click)="reset()" class="fas fa-undo">
        </button>
    </div>
    
    <ngx-editor id="payment-editor-container" [editor]="editor" [(ngModel)]="payment.section.value" (ngModelChange)="onEditorChange($event)">
    </ngx-editor>
</div>
